// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"212":"121892ae","424":"d43b9c02","560":"7795ee25","566":"7795ee25"}[chunkId] + ".chunk.css";
};